import { combineReducers } from 'redux';

import type { InvoiceUIFiltersReducer } from './filters';
import filters from './filters';
import type { InvoiceUIModalReducer } from './modal';
import modal from './modal';

export interface InvoiceUIReducer {
  modal: InvoiceUIModalReducer;
  filters: InvoiceUIFiltersReducer;
}

export default combineReducers({
  modal,
  filters
});
